import { Spin } from "antd";
import { PictureOutlined, CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";
import styles from "./styles.module.less";

interface ImagePreviewProps {
  fileUrl?: string;
  fileName: string;
  isUploading: boolean;
  onRemove?: () => void;
}

export const ImagePreview = ({
  fileUrl,
  fileName,
  isUploading,
  onRemove,
}: ImagePreviewProps) => {
  return (
    <div className={styles.imagePreview}>
      <div className={styles.uploadingPlaceholder}>
        {fileUrl ? (
          <img src={fileUrl} alt={fileName} className={styles.previewImage} />
        ) : (
          <div className={styles.uploadingIconWrapper}>
            <PictureOutlined className={styles.uploadingIcon} />
          </div>
        )}
        {isUploading && (
          <div className={styles.uploadingOverlay}>
            <Spin size="large" />
            <span className={styles.uploadingText}>Đang tải...</span>
          </div>
        )}
      </div>
      {!isUploading && onRemove && (
        <Button
          type="text"
          icon={<CloseOutlined />}
          className={styles.removeButton}
          onClick={onRemove}
        />
      )}
    </div>
  );
};
